import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import teamService from '../../services/teamService';
import './TeamList.css';

const TeamLogo = ({ badge, name }) => {
  // Substitua 'seu-cloud-name' e 'badges/' pelo seu caminho correto no Cloudinary
  const cloudinaryBaseUrl = 'https://res.cloudinary.com/seu-cloud-name/image/upload/v1/badges/';

  const getImageUrl = (badgeValue) => {
    if (!badgeValue) {
      return '/default-team-badge.png';
    }
    if (badgeValue.startsWith('http')) {
      return badgeValue;
    }
    return cloudinaryBaseUrl + badgeValue;
  };

  const [imgSrc, setImgSrc] = useState(getImageUrl(badge));

  useEffect(() => {
    setImgSrc(getImageUrl(badge));
  }, [badge]);

  const handleError = () => {
    setImgSrc('/default-team-badge.png');
  };

  return (
    <div className="team-logo">
      <img
        src={imgSrc}
        alt={`Logo do time ${name}`}
        onError={handleError}
      />
    </div>
  );
};

function TeamList() {
  const [teams, setTeams] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    const fetchTeams = async () => {
      try {
        const data = await teamService.getAll();
        if (Array.isArray(data)) {
          setTeams(data);
        } else {
          setError('Formato de dados inválido');
        }
      } catch (err) {
        console.error('Erro ao carregar times:', err);
        setError('Erro ao carregar lista de times');
      } finally {
        setLoading(false);
      }
    };

    fetchTeams();
  }, []);

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm('Tem certeza que deseja excluir este time?');
    if (!confirmDelete) return;

    try {
      await teamService.deleteTeam(id);
      setTeams((prev) => prev.filter((team) => team._id !== id));
    } catch (err) {
      alert('Erro ao excluir time');
      console.error(err);
    }
  };

  const filteredTeams = teams.filter(team =>
    team.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    team.city.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (loading) {
    return (
      <div className="team-list-container">
        <h2>Lista de Times</h2>
        <p>Carregando...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="team-list-container">
        <h2>Lista de Times</h2>
        <div className="error-message">{error}</div>
        <Link to="/" className="back-link">
          Voltar para a página inicial
        </Link>
      </div>
    );
  }

  return (
    <div className="team-list-container">
      <div className="header">
        <h2>Lista de Times</h2>
        <Link to="/teams/new" className="new-team-button">
          Novo Time
        </Link>
      </div>

      <div className="search-container">
        <input
          type="text"
          placeholder="Buscar times por nome ou cidade..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      {filteredTeams.length === 0 ? (
        <div className="no-teams">
          <p>Nenhum time encontrado</p>
          <Link to="/teams/new">Cadastre um novo time</Link>
        </div>
      ) : (
        <div className="teams-grid">
          {filteredTeams.map((team) => (
            <div key={team._id} className="team-card">
              <div className="team-header">
                <TeamLogo badge={team.badge} name={team.name} />
                <div className="team-info">
                  <h3>{team.name}</h3>
                  <p>{team.city}</p>
                  {team.foundedYear && <p>Fundado em {team.foundedYear}</p>}
                </div>
              </div>

              <div className="team-championships">
                <h4>Campeonatos:</h4>
                {team.championships?.length > 0 ? (
                  <ul>
                    {team.championships.slice(0, 3).map((champ) => (
                      <li key={champ._id}>{champ.name}</li>
                    ))}
                    {team.championships.length > 3 && (
                      <li>+{team.championships.length - 3} mais</li>
                    )}
                  </ul>
                ) : (
                  <p>Nenhum campeonato</p>
                )}
              </div>

              <div className="team-actions">
                <Link to={`/teams/${team._id}`} className="button details">
                  Detalhes
                </Link>
                <Link to={`/teams/${team._id}/edit`} className="button edit">
                  Editar
                </Link>
                <button
                  onClick={() => handleDelete(team._id)}
                  className="button delete"
                >
                  Excluir
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default TeamList;
